import React from 'react';
import { Wrapper, Label, LightLabel } from './styled';
import { WsAddButton } from '../WSActionBar/components/LeftGroup';
import { useSelector } from 'react-redux';
import { selectIsAdmin } from 'store/Faraday/selectors';
import { selectIsFiltering } from 'store/Filters/selectors';
import NoSearchResults from 'Common/Components/NoSearchResults';

const EmptyState = () => {
  const isAdmin = useSelector(selectIsAdmin);
  const isFiltering = useSelector((state) => selectIsFiltering('workspaces', state));
  if (isFiltering) return <Wrapper><NoSearchResults /></Wrapper>;
  return (
    <Wrapper>
      <Label>You currently have 0 Workspaces</Label>
     { isAdmin
       ? <>
        <LightLabel>Start by creating one</LightLabel>
        <WsAddButton />
         </>
       : <LightLabel>Please contact your admin.</LightLabel>
      }
    </Wrapper>
  );
};

export default EmptyState;
